import React from 'react';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import styled from 'styled-components';
import { FormGroup, Label, ReactSelectCSS } from 'components/Shared/Forms';
import { SCAFFOLDING, TYPOGRAPHY, INPUTS } from 'theme';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import { roundLatLng } from 'utils/maps';
import notify from 'utils/notify';

const AutocompleteItem = ({ formattedSuggestion }) => (
    <div>
        <strong>{formattedSuggestion.mainText}</strong> <small>{formattedSuggestion.secondaryText}</small>
    </div>
);

const StyledFormGroup = styled(FormGroup)`
    ${ReactSelectCSS}

    .Select-control {
        padding-left: ${SCAFFOLDING.GUTTER};
        outline: none;
        cursor: text;
    }

    .Select-menu-outer {
        max-height: none;
        padding-bottom: 36px;
        background-image: url('/images/powered_by_google.png');
        background-position: right ${INPUTS.PADDING.X} bottom ${INPUTS.PADDING.X};
        background-repeat: no-repeat;
        background-size: 144px 18px;
    }

    .Select-option:last-child {
        border-bottom: 1px solid ${SCAFFOLDING.BORDER_COLOR};
    }
`;

const StyledFormControlHelper = styled.div`
    position: relative;
`;

const StyledIcon = styled(Icon)`
    position: absolute;
    top: 50%;
    left: 0.65em;
    color: ${TYPOGRAPHY.COLOR_REDUCED};
    font-size: ${TYPOGRAPHY.FONT_SIZE.LARGE};
    pointer-events: none;
    transform: translate(0, -50%);
`;

class GooglePlacesSearch extends React.Component {
    state = { search: '' };

    handleSearch = (search) => {
        this.setState({ search });
    };

    handleSelect = (search) => {
        this.setState({ search }, () => {
            geocodeByAddress(this.state.search)
                .then((results) => {
                    if (results && results.length > 0) {
                        const { location } = results[0].geometry;
                        this.props.input.onChange(roundLatLng(location));
                    }
                })
                .catch(() => notify.error('Failed to find location. Please try again.'));
        });
    };

    render() {
        const {
            input: { name },
        } = this.props;
        const inputProps = {
            id: name,
            onChange: this.handleSearch,
            value: this.state.search,
            placeholder: 'Enter a name or address',
            autoComplete: 'off',
        };
        return (
            <StyledFormGroup width="100%">
                <Label htmlFor={inputProps.id}>Search for a location</Label>
                <StyledFormControlHelper>
                    <PlacesAutocomplete
                        classNames={{
                            root: 'Select',
                            input: 'Select-control',
                            autocompleteContainer: 'Select-menu-outer',
                            autocompleteItem: 'Select-option',
                        }}
                        onSelect={this.handleSelect}
                        onEnterKeyDown={this.handleSelect}
                        inputProps={inputProps}
                        autocompleteItem={AutocompleteItem}
                    />
                    <StyledIcon glyph={GLYPHS.SEARCH} />
                </StyledFormControlHelper>
            </StyledFormGroup>
        );
    }
}

export default GooglePlacesSearch;
